<template>
  <div>
    <vue-dropzone
      id="customdropzone"
      ref="imgDropZone"
      :options="dropzoneOptions"
      @vdropzone-complete="afterComplete"
    ></vue-dropzone>
  </div>
</template>

<script>
import firebase from 'firebase'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    uID: {
      type: String
    }
  },
  data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: '.jpg, .jpeg, .png',
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Arrastre la imagen o Click aquí</p>
          <p class="form-text">Solo formatos: .jpg, .jpeg, .png</p>
          `
      },
      images: []
    }
  },
  methods: {
    async afterComplete(upload) {
      const imageName = `${new Date()}${upload.name}`
      const { type } = upload
      this.isLoading = true
      try {
        // save image
        const file = upload
        const metadata = {
          contentType: type
        }
        const storageRef = firebase.storage().ref()
        const imageRef = storageRef.child(
          `imagesProductRoot/${this.uID}/${imageName}`
        )
        await imageRef.put(file, metadata)
        const downloadURL = await imageRef.getDownloadURL()
        const fileObj = { nombre: imageName, path: downloadURL }
        this.$emit('addFile', fileObj)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
      this.$refs.imgDropZone.removeFile(upload)
    }
  }
}
</script>

<style>
.image-div {
  display: flex;
  margin: 25px;
}
.image {
  max-width: 250px;
  margin: 15px;
}
</style>
